import { render, staticRenderFns } from "./groupAlbum.vue?vue&type=template&id=6ffb9f7c&scoped=true"
import script from "./groupAlbum.vue?vue&type=script&lang=js"
export * from "./groupAlbum.vue?vue&type=script&lang=js"
import style0 from "./groupAlbum.vue?vue&type=style&index=0&id=6ffb9f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffb9f7c",
  null
  
)

export default component.exports